import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ba74714feac1f04a0eca329f90336a9a.jpg"
          alt="Ruined cityscape – The Wraith stands against the apocalypse"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />
      <div className="absolute inset-0 bg-[#8B1A1A]/15" />

      {/* Film grain texture */}
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Content */}
      <div
        className={`relative z-10 w-full max-w-5xl mx-auto px-6 text-center transition-all duration-1000 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        {/* Tag */}
        <div className="inline-flex items-center gap-2 border border-[#C8922A]/60 px-4 py-1.5 mb-8">
          <span className="w-1.5 h-1.5 bg-[#C8922A] rounded-full animate-pulse" />
          <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.25em] uppercase">
            Green Monday — Year 3
          </span>
        </div>

        {/* Main Title */}
        <h1 className="font-['Special_Elite'] text-white leading-tight mb-6">
          <span className="block text-5xl md:text-7xl lg:text-8xl drop-shadow-2xl">
            She Already
          </span>
          <span className="block text-5xl md:text-7xl lg:text-8xl text-[#C8922A] drop-shadow-2xl">
            Lost Him Once.
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-[#AAAAAA] text-sm md:text-base font-['Rajdhani'] tracking-[0.1em] max-w-xl mx-auto mb-10 leading-relaxed">
          Jordan Reyes. Scavenger. Survivor. <span className="text-white">The Wraith.</span><br />
          Her journey isn't about survival anymore — it's about keeping a promise.
        </p>

        {/* CTA Buttons */}
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <button
            onClick={() => navigate("/book")}
            className="flex items-center gap-2 bg-[#C8922A] hover:bg-[#D9A030] text-black font-['Share_Tech_Mono'] text-xs tracking-[0.2em] uppercase px-8 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line text-sm" />
            Read The Book
          </button>
          <button
            onClick={() => document.getElementById("story")?.scrollIntoView({ behavior: "smooth" })}
            className="bg-[#8B1A1A] hover:bg-[#A52020] text-white font-['Share_Tech_Mono'] text-xs tracking-[0.2em] uppercase px-8 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Read Her Story
          </button>
          <button
            onClick={() => document.getElementById("characters")?.scrollIntoView({ behavior: "smooth" })}
            className="border border-white/40 hover:border-white text-white font-['Share_Tech_Mono'] text-xs tracking-[0.2em] uppercase px-8 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Meet The Characters
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="font-['Share_Tech_Mono'] text-[#555] text-xs tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-[#C8922A] text-lg" />
      </div>
    </section>
  );
}
